export default [
  {
    path: "/linkbase64",
    name: "LinkBASE64",
    component: () => import("../views/linkbase64.vue"),
  },
];